import React, { useState } from "react";

function DatePickerDropdown({ onChange }) {
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [day, setDay] = useState("");

  // Función para manejar cambios en los campos de año, mes y día
  const handleYearChange = (e) => {
    setYear(e.target.value);
    onChange(`${e.target.value}-${month}-${day}`);
  };

  const handleMonthChange = (e) => {
    setMonth(e.target.value);
    onChange(`${year}-${e.target.value}-${day}`);
  };

  const handleDayChange = (e) => {
    setDay(e.target.value);
    onChange(`${year}-${month}-${e.target.value}`);
  };

  // Listas de opciones para los selects
  const years = Array.from(
    { length: 100 },
    (_, i) => new Date().getFullYear() - 99 + i
  ).reverse();
  const months = Array.from({ length: 12 }, (_, i) =>
    String(i + 1).padStart(2, "0")
  );
  const days = Array.from({ length: 31 }, (_, i) =>
    String(i + 1).padStart(2, "0")
  );

  return (
    <div className="DateContThree">

      <div className="Cont3Select">
        <select value={year} onChange={handleYearChange} required>
          <option value="">Year</option>
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      <div className="Cont3Select">
        <select value={month} onChange={handleMonthChange} required>
          <option value="">Month</option>
          {months.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
      </div>

      <div className="Cont3Select">
        <select value={day} onChange={handleDayChange} required>
          <option value="">Day</option>
          {days.map((d) => (
            <option key={d} value={d}>
              {d}
            </option>
          ))}
        </select>
      </div>

    </div>
  );
}

export default DatePickerDropdown;
